/**
 * Generic `Result<Ok, Err>` for the routing utility. Steps return Results and
 * the executor aggregates — throwing is reserved for programmer errors only.
 */

export type Result<Ok, Err> = { readonly ok: true; readonly value: Ok } | { readonly ok: false; readonly error: Err }

export const ok = <Ok>(value: Ok): Result<Ok, never> => ({ ok: true, value })

export const err = <Err>(error: Err): Result<never, Err> => ({ ok: false, error })

export const isOk = <Ok, Err>(r: Result<Ok, Err>): r is { readonly ok: true; readonly value: Ok } => r.ok

export const isErr = <Ok, Err>(r: Result<Ok, Err>): r is { readonly ok: false; readonly error: Err } => !r.ok

/**
 * Exhaustiveness guard for discriminated-union switches. Place in the `default`
 * branch — adding a variant without handling it becomes a compile error.
 */
export const assertNever = (x: never): never => {
  throw new Error(`Unhandled discriminant: ${JSON.stringify(x)}`)
}
